import React from 'react';
import { FiEye } from 'react-icons/fi';

import styles from '../../contractDetails.module.scss';

interface ProcessingStatusProps {
  label: string;
  icon: React.ReactNode;
  description: string;
  showEyeButton?: boolean;
  onViewDetails?: () => void;
}

export function ProcessingStatus( {
  label,
  icon,
  description,
  showEyeButton = false,
  onViewDetails
}: ProcessingStatusProps ) {
  return (
    <div className={ styles.statusSection }>
      <div className={ styles.subsectionHeader }>
        <h4 className={ styles.subsectionTitle }>Processing Status</h4>
        { showEyeButton && onViewDetails && (
          <button
            className={ styles.eyeButton }
            onClick={ onViewDetails }
            title='View task details'
            data-testid='view-processing-button'
          >
            <FiEye size={ 20 } />
          </button>
        ) }
      </div>
      <div className={ styles.statusRow }>
        <span className={ styles.statusLabel } data-testid='processing-status-label'>
          { label }
        </span>
        { icon }
      </div>
      <p className={ styles.statusDescription }>{ description }</p>
    </div>
  );
}
